import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModelData } from 'yt-ng-framework';

@Component({
  selector: 'yt-instrukcije-za-placanja',
  templateUrl: './instrukcije-za-placanja.component.html'
})
export class InstrukcijeZaPlacanjaComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
  ) { }

  Config={};
  items = [];
  modelData: ModelData;
  @Input() Parameters;

  ngOnInit() {
    this.items = this.Parameters[0].Value;
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      ShowCheckBoxes: true,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel
    }
  }

  Save(){
    let _instrukcija: string = null;
    if (this.items){
      _instrukcija = "";
      this.items.forEach(item =>{      

        if (item.Checked){
          _instrukcija += item.Instrukcija + "\n\n";          
        }
      })
    }
    this.activeModal.close(_instrukcija);  
  }
  
  Close(){
    this.activeModal.dismiss();
  }
}
